import CustomerTransactions from '@/views/GeneralJournal/CustomerTransactions';
import GeneralJournal from '@/views/GeneralJournal/GeneralJournal';
import GeneralLedger from '@/views/GeneralJournal/GeneralLedger';
import { requiresGeneralJournalAccess } from './helpers';

export default [
  {
    path: '/customer-transactions',
    name: 'CustomerTransactions',
    component: CustomerTransactions,
    beforeEnter: requiresGeneralJournalAccess,
    meta: { group: 'generalJournal', roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'ACCOUNTANT'] },
  },
  {
    path: '/general-journal',
    name: 'GeneralJournal',
    component: GeneralJournal,
    beforeEnter: requiresGeneralJournalAccess,
    meta: { group: 'generalJournal', roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'ACCOUNTANT'] },
  },
  {
    path: '/generalLedger',
    name: 'GeneralLedger',
    component: GeneralLedger,
    beforeEnter: requiresGeneralJournalAccess,
    meta: { group: 'generalJournal', roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'ACCOUNTANT'] },
  },
];
